import { ServiceExtraForm } from '@components';
import { L } from '@lib';
import { Utils } from '@utils';
import { Col, Input, InputNumber, Row, Typography } from 'antd';
import React from 'react';
import { IServiceDetailsPresentation, headerRowStyle, headerLabelStyle, dataRowStyle } from './ServiceDetailsCard.props';

const { Text } = Typography;

export const ServiceDetailsTechnician: React.FC<IServiceDetailsPresentation> = ({
  service,
  disabled,
  parts,
  onRemovePart,
  onUpdatePart,
  handleDurationUpdate,
  handleNoteUpdate,
}) => (
  <>
    {/* Header row */}
    <Row gutter={16} style={headerRowStyle}>
      <Col span={12}>
        <Text style={headerLabelStyle}>Name</Text>
      </Col>
      <Col span={12}>
        <Text style={headerLabelStyle}>{Utils.durationLabel(service.duration)}</Text>
      </Col>
    </Row>

    {/* Data row */}
    <Row gutter={16} style={dataRowStyle}>
      <Col span={12}>
        <Text style={{ fontSize: 14, fontWeight: 500 }}>{service.name}</Text>
      </Col>
      <Col span={12}>
        <InputNumber
          min={0}
          step=".01"
          precision={2}
          style={{ width: '100%' }}
          placeholder={L('Duration')}
          disabled
          value={service.duration}
          onChange={(value: number | null) =>
            handleDurationUpdate(service.id, value !== null ? Number(Utils.formatNumber(value, 2)) : 0)
          }
        />
      </Col>
      <Col span={24} style={{ marginTop: 10 }}>
        <Input.TextArea
          rows={1}
          autoSize={{ minRows: 1, maxRows: 3 }}
          placeholder={L('Note')}
          value={service.note || ''}
          disabled={disabled}
          onChange={(e) => handleNoteUpdate(service.id, e.target.value)}
        />
      </Col>
    </Row>

    {/* Parts */}
    {parts.length > 0 && (
      <div style={{ marginTop: 12, borderTop: '1px solid #f0f0f0', paddingTop: 10 }}>
        {parts.map((servicePart, index) => (
          <ServiceExtraForm
            key={`${service.id}part${index}`}
            index={index}
            extra={servicePart}
            onRemove={() => onRemovePart(index)}
            onUpdate={(values) => onUpdatePart(index, values)}
            disabled
          />
        ))}
      </div>
    )}
  </>
);
